<template>
    <div class="ma-4">
        <ClientNav/>
        <v-row dense>
            <v-col cols="12">
                <v-card>
                    <v-card-title style="background-color: #2b3990">
                        <span class="headline white--text">{{ titleForm }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-text-field
                                        v-model="newAllergy"
                                        label="Allergy Name"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            fab
                            small
                            @click="showPrintModal()"
                            class="mr-8 mb-2 white--text"
                            color="#2b6993"
                            elevation="4"
                            v-if="!createAllergy"
                        >
                            <v-icon>print</v-icon>
                        </v-btn>
                        <v-btn
                            class="white--text"
                            color="#259647"
                            @click="addAllergy()"
                            v-if="createAllergy"
                        >Save
                        </v-btn
                        >
                        <v-btn
                            color="blue darken-1 white--text"
                            @click="updateAllergy()"
                            v-if="!createAllergy"
                        >Update
                        </v-btn
                        >
                        <v-btn color="blue darken-1" text @click="close"
                        >Cancel
                        </v-btn
                        >
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <Foot/>
    </div>
</template>

<script>
import axios from "axios";
import ClientNav from "@/components/ClientNav";
import Foot from "../../../components/Footer";
import {displaySuccess, displayError} from "@/service/notification-message.service";
import PrintUtil from "../../../../utils/print-util";

const url = require("../../../client_config/config").url;

export default {
    components: {
        Foot,
        ClientNav,
    },
    data: function () {
        return {
            msg: false,
            search: "",
            text: "",
            allergies: [],
            clientID: this.$route.params.clientID,
            allergyId: this.$route.params.id,
            token: localStorage.getItem('token'),
            titleForm: "New Allergy",
            allergyID: "",
            newAllergy: "",
            editedIndex: -1,
            editedItem: {
                allergy: "",
            },
            defaultItem: {
                allergy: "",
            },
            isLoading: true,
            allergy: {},
            createAllergy: false
        };
    },

    computed: {},

    watch: {},

    created() {

        console.log({clientId: this.clientID});
        this.createAllergy = this.$route.query.createAllergy === 'true'
        this.getAllergies();
    },

    mounted() {
        if (!this.createAllergy) {
            this.getAllergy();
        }

        window.addEventListener('keydown', async (event) => {
            this.downloadUrl = await this.generateDownloadUrl();
            PrintUtil.handleKeydown(event, this.downloadUrl, this.allergyId, this.token, 'Allergies');
        });
    },

    beforeDestroy() {
        window.removeEventListener('keydown', (event) => {
            PrintUtil.handleKeydown(event, this.downloadUrl, this.allergyId, this.token, 'Allergies');
        });
    },


    methods: {
        initialize() {
            this.allergies = [];
        },

        viewAllergy(item) {
            this.titleForm = "Viewing " + item.Allergy;
            this.newAllergy = item.Allergy;
            this.allergyID = item._id;
        },

        close() {
            this.$router.go(-1);
            this.newAllergy = "";
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        async updateAllergy() {
            let req_body = {
                Allergy: this.newAllergy,
            };

            try {
                const response = await axios.put(`${url}/allergies/${this.allergyID}`, req_body);
                if (response.status !== 200) {
                    displayError("An error occurred while updating the allergy.")
                }
                displaySuccess("The allergy has been updated successfully.");
                this.getAllergies();
            } catch (error) {
                displayError(error);
            } finally {
                this.close();
            }
        },

        getAllergies() {
            this.isLoading = true;
            axios.get(`${url}/allergies/allergy`, {
                params: {
                    ClientId: this.clientID,
                },
            })
                .then((res) => {
                    this.allergies = res.data.allergies;
                })
                .finally(() => (this.isLoading = false));
        },

        async addAllergy() {
            let req_body = {
                Allergy: this.newAllergy,
                ClientID: this.clientID,
            };

            try {
                const response = await axios.post(`${url}/allergies`, req_body);
                if (response.status !== 200) {
                    displayError("An error occurred while adding the allergy.")
                }
                displaySuccess("The new allergy has been added successfully.");
                this.getAllergies();
            } catch (error) {
                displayError(error);
            } finally {
                this.close();
            }
        },

        getAllergy() {
            this.isLoading = true;
            axios
                .get(`${url}/allergies/${this.allergyId}`)
                .then((res) => {
                    this.allergy = res.data.allergy;
                    this.viewAllergy(this.allergy);
                })
                .finally(() => (this.isLoading = false));
        },

        async generateDownloadUrl() {
            return `${url}/allergies/print?id=${this.allergyId}`;
        },

        async showPrintModal() {
            this.downloadUrl = await this.generateDownloadUrl();
            PrintUtil.showPrintOption(this.downloadUrl, this.allergyId, this.token,'Allergies');
        },
    },
};
</script>
